// @unocss-include
import Layout from '@/components/layout/sider-menu-layout/index.vue';
import type { SiteRouteItem } from '@/router/types';
import { PermissionPageKey } from '@/types/permission';

const route: SiteRouteItem = {
  path: '/development',
  component: Layout,
  name: PermissionPageKey.Development,
  meta: {
    title: 'site_route_item.development',
    icon: 'mdi:customer-service',
    iconCls: 'bg-violet-500',
  },
  redirect: '/development/dashboard', // 默认首页子路由
  children: [
    {
      path: 'dashboard',
      name: PermissionPageKey.DevelopmentDashboard,
      component: () => import('../pages/dashboard/index.vue'),
      meta: {
        title: 'site_route_item.development.dashboard',
        icon: 'material-symbols:dashboard',
      },
    },
    {
      path: 'dashboard/version',
      name: PermissionPageKey.DevelopmentDashboardVersion,
      component: () => import('../pages/dashboard/version.vue'),
      meta: {
        title: 'site_route_item.development.version',
        icon: 'mdi:compare',
        hideInMenu: true,
      },
    },
    {
      path: 'dashboard/report',
      name: PermissionPageKey.DevelopmentDashboardReport,
      component: () => import('../pages/dashboard/report.vue'),
      meta: {
        title: 'site_route_item.development.report',
        icon: 'tabler:report',
        hideInMenu: true,
      },
    },
    {
      path: 'dev/demand-list',
      name: PermissionPageKey.DevelopmentDemandList,
      component: () => import('../pages/dev-list/demand-list.vue'),
      meta: {
        title: 'site_route_item.development.demand_list',
        icon: 'tabler:report',
        hideInMenu: true,
      },
    },
    {
      path: 'dev/test-record-list',
      name: PermissionPageKey.DevelopmentTestRecordList,
      component: () => import('../pages/dev-list/test-record-list.vue'),
      meta: {
        title: 'site_route_item.development.test_record_list',
        icon: 'tabler:report',
        hideInMenu: true,
      },
    },
    {
      path: 'dev/test-report-list',
      name: PermissionPageKey.DevelopmentTestReportList,
      component: () => import('../pages/dev-list/test-report-list.vue'),
      meta: {
        title: 'site_route_item.development.test_report_list',
        icon: 'tabler:report',
        hideInMenu: true,
      },
    },
    {
      path: 'accident-review',
      name: PermissionPageKey.CloudtestAccidentReview,
      component: () => import('../pages/accident-review/index.vue'),
      meta: {
        title: 'site_route_item.development.accident_review',
        icon: 'simple-icons:codereview',
      },
    },
    {
      path: 'client-performance-report',
      name: PermissionPageKey.DevelopmentClientPerformanceReport,
      component: () => import('../pages/client-performance-report/reportsList.vue'),
      meta: {
        title: 'site_route_item.development.client_performance_report',
        icon: 'tabler:report',
        // roles: ['admin'],
        // hideInMenu: true,
      },
    },
    {
      path: 'client-performance-case-detail',
      name: PermissionPageKey.DevelopmentClientPerformanceCaseDetail,
      component: () => import('../pages/client-performance-report/caseDetail.vue'),
      meta: {
        title: 'site_route_item.development.client_performance_case_detail',
        icon: 'tabler:report',
        hideInMenu: true,
      },
    },
    {
      path: 'ui-automation-report',
      name: PermissionPageKey.DevelopmentUIAutomationReport,
      component: () => import('../pages/ui-automation-report/index.vue'),
      meta: {
        title: 'site_route_item.development.ui_automation_report',
        icon: 'tabler:report',
      },
    },
  ],
};

export default route;
